"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductExpandEnum = exports.ProductBuilderTypeEnum = exports.OrderByProductEnum = exports.ProductStateEnum = void 0;
var ProductStateEnum;
(function (ProductStateEnum) {
    ProductStateEnum["VALID"] = "valid";
    ProductStateEnum["IN_PROGRESS"] = "in_progress";
})(ProductStateEnum = exports.ProductStateEnum || (exports.ProductStateEnum = {}));
var OrderByProductEnum;
(function (OrderByProductEnum) {
    OrderByProductEnum["ID"] = "id";
    OrderByProductEnum["NAME"] = "name";
    OrderByProductEnum["PRICE"] = "price";
    OrderByProductEnum["DURATION"] = "duration";
    OrderByProductEnum["PRODUCT_SUB_TYPE"] = "productSubType";
    OrderByProductEnum["STATUS"] = "status";
})(OrderByProductEnum = exports.OrderByProductEnum || (exports.OrderByProductEnum = {}));
var ProductBuilderTypeEnum;
(function (ProductBuilderTypeEnum) {
    ProductBuilderTypeEnum["RENTAL"] = "rental";
    ProductBuilderTypeEnum["PROGRAM_PUNCH_PASS"] = "program_punch_pass";
    ProductBuilderTypeEnum["RENTAL_PUNCH_PASS"] = "rental_punch_pass";
})(ProductBuilderTypeEnum = exports.ProductBuilderTypeEnum || (exports.ProductBuilderTypeEnum = {}));
var ProductExpandEnum;
(function (ProductExpandEnum) {
    ProductExpandEnum["PRICES"] = "prices";
    ProductExpandEnum["REQUIRED_PRODUCTS"] = "requiredProducts";
    ProductExpandEnum["ENTITLEMENT_DISCOUNTS"] = "entitlementDiscounts";
})(ProductExpandEnum = exports.ProductExpandEnum || (exports.ProductExpandEnum = {}));
//# sourceMappingURL=product.enums.js.map